import React from 'react'
import { breakpoints } from 'ui/acro'
import InstructorResultCard from '../CardStyles/InstructorResultCard'
import Carousel from 'components_v2/Home/SignedIn/common/components/Carousel/Carousel'

const InstructorsResultsCarousel = ({ data }) => {
  const instructorsData = data && data.instructors.top
  return (
    <Carousel
      card={InstructorResultCard}
      carouselTitle={'InstructorsTopResults'}
      data={instructorsData}
      mx={['16px', '16px', '16px', '0px']}
      breakpoints={{
        0: {
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        320: {
          slidesPerView: 2.4,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        375: {
          slidesPerView: 2.7,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        [breakpoints[1]]: {
          slidesPerView: 3.4,
          spaceBetween: 20,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        768: {
          slidesPerView: 3.4,
          spaceBetween: 20,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        [breakpoints[2]]: {
          slidesPerView: 5,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        }
      }}
    />
  )
}

export default InstructorsResultsCarousel
